"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var page = require('page');
var React = require("react");
var react_redux_1 = require("react-redux");
var constants_1 = require("../../constants");
var icons_component_1 = require("../../components/icons.component");
function DeletePassportSuccess(_a) {
    var content = _a.content, route = _a.route, transitionOutHandler = _a.transitionOutHandler;
    var mainLink;
    if (route.isFlow) {
        mainLink = constants_1.default.BASE_URI + "/flow-return/" + route.enter.flow;
    }
    else {
        mainLink = "" + constants_1.default.BASE_URI;
    }
    return (React.createElement("div", { className: "generic-container" },
        React.createElement(icons_component_1.IllustrationComponent, { modifierClass: "successImg", image: "Success" }),
        React.createElement("h2", { className: "generic-header" }, content.passport.remove.success),
        React.createElement("a", { className: "test_done vx_btn vx_btn-block modal_btn", onClick: transitionOutHandler, "data-name": "done", href: mainLink }, content.common.done)));
}
var mapStateToProps = function (_a) {
    var content = _a.content, route = _a.route;
    return ({
        content: content,
        route: route
    });
};
exports.default = react_redux_1.connect(mapStateToProps)(DeletePassportSuccess);
